module.exports = __webpack_public_path__ + "assets/img/tx11g_4.b75e5e21.jpg";